module.exports = __webpack_public_path__ + "img/sport_volleyball.9aa73138.png";